import { toast } from "react-toastify";

const showToast = (message, type = "error") => {
  toast(message, { type, position: toast.POSITION.TOP_CENTER, autoClose: 1000 });
};

const formatDateTime = (value) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(value);
  return `${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()} ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()} ${
    date.getHours() > 9 ? date.getHours() : "0" + date.getHours()
  }:${date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()}:${
    date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds()
  }`;
};
const formatDateTimeComponent = (value) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(value);

  return (
    <div className="flex flex-col w-full justify-center">
      <span>
        {`${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()} ${
          monthNames[date.getMonth()]
        } ${date.getFullYear()} `}
      </span>
      <span className="mt-1">
        {`${date.getHours() > 9 ? date.getHours() : "0" + date.getHours()}:${
          date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()
        }:${
          date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds()
        }`}
      </span>
    </div>
  );
};

const formatDate = (value) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(value);
  return `${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()} ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()}`;
};

const getLastDayOfMonth = (year, month) => new Date(year, month, 0).getDate();

const formatDateYMD = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDefaultDates = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const monthStr = month > 9 ? month : `0${month}`;
  return {
    periodFrom: `${year}-${monthStr}-01`,
    periodTo: `${year}-${monthStr}-${getLastDayOfMonth(year, month)}`,
  };
};


const parseExcelDate = (dateValue) => {
  if (!dateValue) return "";
  
  if (dateValue instanceof Date) {
    return dateValue.toISOString().slice(0, 10);
  }
  
  const strValue = dateValue.toString().trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(strValue)) {
    return strValue;
  }
  
  const parsedDate = new Date(dateValue);
  if (!isNaN(parsedDate.getTime())) {
    return parsedDate.toISOString().slice(0, 10);
  }
  
  return strValue;
};

const normalizeInventoryStatus = (statusInput) => {
  if (!statusInput) return "SELL_IN";
  
  let normalized = statusInput.toString().toUpperCase().trim().replace(/\s+/g, "_");
  
  if (normalized === "SELLIN") normalized = "SELL_IN";
  if (normalized === "SELLOUT") normalized = "SELL_OUT";
  
  if (!["SELL_IN", "SELL_OUT", "ACTIVATED"].includes(normalized)) {
    throw new Error(`Invalid status "${statusInput}". Must be SELL_IN, SELL_OUT, or ACTIVATED`);
  }
  
  return normalized;
};

export { 
  formatDate, 
  formatDateTime, 
  formatDateTimeComponent, 
  formatDateYMD, 
  getLastDayOfMonth, 
  getDefaultDates, 
  showToast,
  parseExcelDate,
  normalizeInventoryStatus
};
